/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

define([
	'@waca/dashboard-common/js/core/APIFactory',
	'./SaveAPI'
], (APIFactory, SaveAPI) => {

	/**
	 * @implements {SaveAPI}
	 */
	class Save {
		constructor({ features }) {
			this._features = features;
			this._api = APIFactory.createAPI(this, [SaveAPI]);
		}

		getAPI() {
			return this._api;
		}

		destroy() {
			delete this._api;
		}

		save(responseFields){
			const boardID = this._features.internal.getBoardModel().id;
			if (!boardID){
				const code = 'missingDashboardId';
				return Promise.reject({ 'status': 'fail', 'error': Object.assign(new Error(), { code }) });
			}

			return this._getContentService()
				.then(contentService => contentService.saveDashboard(this._features.API, boardID))
				.then(response => this._getResponse(response, responseFields));
		}

		saveAs(name, parentId, overwrite, responseFields){

			let url = parentId;
			if(!url.includes('/')){
				url = 'v1/objects/' + parentId + '/items';
			}

			return this._getContentService()
				.then(contentService => contentService.saveAsDashboard(this._features.API, name, url, overwrite))
				.then(response => this._getResponse(response, responseFields));
		}

		_getContentService(){
			return this._features.API.getServiceWhenReady('.DashboardContent');
		}

		_getResponse(response, responseFields=['status', 'assetId']){
			return this._pick(response, responseFields);

		}

		_pick(response, responseFields){
			const _response = {};
			responseFields.forEach(field => {
				if(response.hasOwnProperty(field)){
					_response[field] = response[field];
				}
			});
			return  _response;
		}
	}
	return Save;
});
